<template>
  <div class="login-container">
    <h3 class="page-header"> {{merchant.name}} </h3>
    <div :class="['page-notice', pageAlert ? 'slide-down' : 'slide-up']">{{pageAlert}}</div>
    <sign-in
        v-if="type === 'sign-in'"
        :baseUrl="baseUrl"
        :joinLink="joinLink"
        :loyalty="merchant.loyalty"
        :appStoreUrl="merchant.app_store_url"
        :playStoreUrl="merchant.google_play_url"
        @setErrors="setErrors"
        @setPageAlert="setPageAlert"
        @updateData="updateData">
    </sign-in>
    <reset-password
        v-else-if="type === 'reset-password'"
        :baseUrl="baseUrl"

        :phoneNumber="phoneNumber"
        @setErrors="setErrors"
        @setPageAlert="setPageAlert"
        @updateData="updateData">
    </reset-password>
    <signature-capture
        v-else-if="type === 'signature-capture'"
        :allowedSmsStored="allowedSmsStored"
        :baseUrl="baseUrl"
        :merchant="merchant"
        :phoneNumber="phoneNumber"
        @setPageAlert="setPageAlert">
    </signature-capture>
  </div>
</template>

<script>
  import SignIn from '@/components/Login/SignIn'
  import ResetPassword from '@/components/Login/ResetPassword'
  import SignatureCapture from '@/components/SignatureCapture/SignatureCapture'
  import config from "../config";

  export default {
    props: {
      merchant: Object,
    },

    name: 'Login',

    components: {
      ResetPassword,
      SignatureCapture,
      SignIn,
    },

    data() {
      return {
        allowedSmsStored: false,
        pageAlert: null,
        phoneNumber: null,
        type: 'sign-in',
      }
    },

    methods: {
      setErrors(error) {
        const message = error ? error : 'please refresh'
        this.setPageAlert(`there was an error, ${message}`)
        this.loading = false
      },

      setPageAlert(alert = null) {
        this.pageAlert = alert
      },

      updateData(field, value) {
        this[field] = value
      },

      urlParams(selectedParam) {
        const urlParams = location.search;
        let params = {};
        if (urlParams) {
          urlParams.substr(1).split("&").forEach(function (item) {
            let key_value = item.split("=");
            if (key_value[0] && key_value[1]) {
              // delete anything that is not a word, space or a dash
              params[key_value[0]] = key_value[1].replace(/[^\w\s\-]/gi, '')
            }
          })
          return params[selectedParam]
        }
      },

    },

    computed: {
      baseUrl: function() {
        return `/merchants/${this.merchant.uuid}`
      },

      joinLink: function() {
        // https://docs.aws.amazon.com/AmazonS3/latest/API/API_GetBucketLocation.html
        // s3 buckets reserve the location param, so it was renamed to m_location before the redirect got to cloudfront
        // rename it back to location when making a request back to the rails app
        const locationParam = this.urlParams('m_location'),
            urlLocation = locationParam ? `?location=${locationParam}` : ''

        const customGroupParam = this.urlParams('custom_group'),
          urlCustomGroup = customGroupParam ? `?custom_group=${customGroupParam}` : ''

        const urlParam = urlLocation || urlCustomGroup

        let urlPhoneNumber = ''
        if (this.phoneNumber) {
          urlPhoneNumber = (urlParam ? '&' : '?') + `input=${this.phoneNumber}`
        }

        return config.joinUrl + '/' + this.merchant.id + urlParam + urlPhoneNumber
      }
    }
}
</script>

<style lang="sass">
.login-container
  padding: 0 1rem
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0

  input[type=number]
    -moz-appearance: textfield

  .page-notice
    transition: all 0.3s ease

    &.slide-up
      opacity: 0
      padding: 0
    &.slide-down
      opacity: 1
      padding: 1rem
</style>
